import { __require as requireGlobalThis } from './node_modules-core-js-internals-global-this.js';
import { __require as requireShared } from './node_modules-core-js-internals-shared.js';
import { __require as requireHasOwnProperty } from './node_modules-core-js-internals-has-own-property.js';
import { __require as requireUid } from './node_modules-core-js-internals-uid.js';
import { __require as requireSymbolConstructorDetection } from './node_modules-core-js-internals-symbol-constructor-detection.js';
import { __require as requireUseSymbolAsUid } from './node_modules-core-js-internals-use-symbol-as-uid.js';

var wellKnownSymbol;
var hasRequiredWellKnownSymbol;

function requireWellKnownSymbol () {
	if (hasRequiredWellKnownSymbol) return wellKnownSymbol;
	hasRequiredWellKnownSymbol = 1;
	var globalThis = requireGlobalThis();
	var shared = requireShared();
	var hasOwn = requireHasOwnProperty();
	var uid = requireUid();
	var NATIVE_SYMBOL = requireSymbolConstructorDetection();
	var USE_SYMBOL_AS_UID = requireUseSymbolAsUid();

	var Symbol = globalThis.Symbol;
	var WellKnownSymbolsStore = shared('wks');
	var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

	wellKnownSymbol = function (name) {
	  if (!hasOwn(WellKnownSymbolsStore, name)) {
	    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
	      ? Symbol[name]
	      : createWellKnownSymbol('Symbol.' + name);
	  } return WellKnownSymbolsStore[name];
	};
	return wellKnownSymbol;
}

export { requireWellKnownSymbol as __require };
//# sourceMappingURL=node_modules-core-js-internals-well-known-symbol.js.map
